/**
 * SEPA creditor identity shown to tenants in the mandate text.
 *
 * The Gläubiger-ID is public (it appears on every mandate and invoice) but it
 * is legally binding: the ID displayed at acceptance time must be the one the
 * collections run under (COL-138). Keep in sync with the SEPA_CREDITOR_ID
 * edge-function secret — the backend stamps the same ID into the Stripe
 * mandate.
 */
export const SEPA_CREDITOR_NAME = "Coliviq GmbH";
export const SEPA_CREDITOR_ID = "DE07ZZZ00002914499";
